var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOffers = function SvgOffers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C0C5D2",
    d: "M23.4 7 19 2.6l-13 13V20h4.4zm-2.8 0L11 16.6 9.4 15 19 5.4zM8 18v-1.6L9.6 18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0C5D2",
    d: "M17 17h-2v5H2V2h13v2h2V0H0v24h17z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0C5D2",
    d: "M12 4H4v2h8zM9 8H4v2h5zM6 12H4v2h2z"
  })));
};
export default SvgOffers;